export default {
	Unknown: -1,
	Rejected: 0, // All orders begin in this status and are moved
	Provisional: 1,
	Complete: 2,
	Cancelled: 4 // Order cancelled having been accepted earlier
};
